/**
 * @module actions/workProvider
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Getting partners from API
 * @return {Promise} Axios promise
 */
export function getPartners () {
  let url = API_URL + '/WorkProvider/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting partner from API
 * @return {Promise} Axios promise
 */
export function getPartner (partnerID) {
  let url = API_URL + '/WorkProvider/Get/' + partnerID
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating/saving a partner
 * @return {Promise} Axios promise
 */
export function CreateSavePartner (data) {
  let url = API_URL + '/WorkProvider/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/workProvider.js